import { GetWelcomeToastDataProps, UseWelcomeToastDataHelpers, WelcomeToastData } from './types'
import { getRangeSummary } from '../../api/analytics/baseEndpoints'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import React from 'react'

export function useWelcomeToastData(): UseWelcomeToastDataHelpers {
  const { isAuthenticated, jwt } = useAuthState()

  const getWelcomeToastData = React.useCallback(
    async ({ dateFilters, dataTypes }: GetWelcomeToastDataProps): Promise<WelcomeToastData> => {
      const emptyWelcomeToastData: WelcomeToastData = {
        scans: 0,
        linkClicks: 0,
        pageViews: 0,
        activeCodes: 0,
        activePages: 0
      }

      if (isAuthenticated) {
        const requests: any[] = dataTypes.map(dataType =>
          getRangeSummary({
            params: {
              event_type_id: dataType.eventTypeId,
              product_id: dataType.productId,
              ...dateFilters
            },
            token: jwt
          })
        )

        return await Promise.all(requests).then((data): WelcomeToastData => {
          return data.reduce((prevToastData, currToastData) => {
            const currTotalActivePages = currToastData?.activePages || 0
            return {
              scans:
                prevToastData.scans +
                (currToastData?.scans + currToastData?.shortUrlClicks + currToastData?.taps || 0),
              linkClicks: prevToastData.linkClicks + (currToastData?.linkClicks || 0),
              pageViews: prevToastData.pageViews + (currToastData?.pageViews || 0),
              activeCodes: prevToastData.activeCodes + (currToastData?.activeCodes || 0),
              activePages:
                prevToastData.activePages +
                (currTotalActivePages === prevToastData.activePages ? 0 : currTotalActivePages)
            }
          }, emptyWelcomeToastData)
        })
      } else {
        return emptyWelcomeToastData
      }
    },
    [isAuthenticated, jwt]
  )

  return { getWelcomeToastData }
}
